var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2505 15.4187L10.1691 15.217L9.95896 15.1389L3.07388 12.5801L3.07388 12.2374L20.6092 5.19448L13.2728 22.0284L12.9159 22.0284L10.2505 15.4187Z",
    stroke: "#969FA2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9659_11288",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 20,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5599 4.28182L2.56379 11.9115L2.56379 12.9156L9.7748 15.5955L12.5664 22.5181L13.6123 22.5181L21.5599 4.28182Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9659_11288)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendLocation);
export default __webpack_public_path__ + "static/media/send-location.88f4b4c2b1a836170a2860aae50ce566.svg";
export { ForwardRef as ReactComponent };